import { Controller } from '@hotwired/stimulus';
import { getCookie } from '../get_cookie';

export default class extends Controller {
  connect() {
    const emid = getCookie('emid');
    if (emid) {
      const script = document.createElement('script');
      script.src = `https://trck.picturepeople.de/trck/etp/?campaign_id=1&type=basketfreeze&emid=${emid}`;
      document.body.append(script);
    }
  }
}
